module.exports = __webpack_public_path__ + "static/media/status2.ca9510bb.png";